import {
  CardHeader,
  CardHeaderProps,
  DialogCloseButton,
} from '@sparemin/blockhead';
import React from 'react';
import { useAuth } from 'ui/context';

export interface AuthCardHeaderProps
  extends Omit<CardHeaderProps, 'actionButton'> {}

/**
 * Header component to be used with `AuthCard`.
 *
 * If the auth card is determined to be inside of a modal, it will render a
 * `DialogCloseButton` that calls the navigator's `close` function when clicked.
 */
const AuthCardHeader: React.FC<AuthCardHeaderProps> = (props) => {
  const { navigation, navigationType } = useAuth();

  const modalProps: Partial<CardHeaderProps> | undefined =
    navigationType === 'url'
      ? undefined
      : {
          actionButton: <DialogCloseButton onPress={navigation.onClose} />,
        };

  return <CardHeader {...props} {...modalProps} />;
};

export default AuthCardHeader;
